import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class ReadingIcon extends AbstractIcon {
  static selector = "reading-icon";

  getHTML() {
    return `<svg version="1.1" baseProfile="basic" id="Layer_1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64"
        xml:space="preserve">
        <path style="fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="M32,36
          v20c0,0-13-5-21-5V41c0,0,2.894-0.83,2.894-3.383C13.894,35,11,34,11,34V21c0,0,12.468,1.723,20.128,5.426
          C32.979,27.319,41.257,23.031,41,16c0-6-5.134-9-9-9s-9,3-9,9c-0.321,6.682,7.234,11.574,10.17,10.234C40.894,21.894,54,21,54,21v13
          c0,0-2.957,0.569-2.957,3.426c0,2.697,2.957,3.511,2.957,3.511V52c0,0-11,1-18,4"/>
        </svg>`
  }
}

componentsRegistryService.define(ReadingIcon);
